import { render, staticRenderFns } from "./quiz-animation.html?vue&type=template&id=346fda85&scoped=true&"
import script from "./quiz-animation.js?vue&type=script&lang=js&"
export * from "./quiz-animation.js?vue&type=script&lang=js&"
import style0 from "./quiz-animation.scss?vue&type=style&index=0&id=346fda85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346fda85",
  null
  
)

export default component.exports